export class VolumeUnit {
    Code: string;
    Name: string;
    PrintAs: string;
  }